<template>
  <VacancyContainer
    :id="vacancyId"
    v-slot="{ company, vacancy }"
    @ready="handleVacancyContainerReady"
  >
    <VRow justify="center">
      <VCol cols="12" md="3" lg="3" xl="2">
        <CompanySmallCard :company="company" />
      </VCol>
      <VCol cols="12" md="8">
        <VCard class="pt-6 pb-8 pt-md-10 pb-md-12 pt-lg-12 pb-lg-14 px-4 px-md-6 px-lg-16">
          <h1 class="apply-success-title text-center mb-4">
            {{ $t('successTitle') }}
          </h1>
          <p class="apply-success-text mb-4">
            {{ $t('successTextOne') }}
          </p>
          <p class="apply-success-text">
            {{ $t('successTextTwo') }}
          </p>
          <VBtn class="d-block mt-8 mx-auto" @click="startInterview">
            {{ $t('passInterviewButton') }}
          </VBtn>
        </VCard>
      </VCol>
    </VRow>
  </VacancyContainer>
</template>

<script>
import VacancyContainer from '../components/Vacancy/VacancyContainer.vue';
import CompanySmallCard from '../components/Company/CompanySmallCard.vue';
import { safeGet } from '../functions';

export default {
  name: 'ApplySuccess',
  components: {
    VacancyContainer,
    CompanySmallCard,
  },
  props: {
    vacancyId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    candidate() {
      const candidate = safeGet(this.$store.state.candidate, ['data', 'candidate']);

      if (!candidate || candidate.vacancyId !== this.vacancyId) {
        return null;
      }

      return candidate;
    },
  },
  methods: {
    handleVacancyContainerReady({ vacancy }) {
      this.pageTitle = `${this.$t('pageTitle')} ${vacancy.title}`;
    },
    startInterview() {
      localStorage.setItem('interviewStep', 2);
      this.$router.push({ name: 'interview', params: { vacancyId: this.vacancyId, step: 2 } });
    },
  },
};
</script>

<style lang="scss" scoped>
  .apply-success-title {
    font-size: 1.5rem;
    font-weight: 400;
  }
  .apply-success-text {
    max-width: 35rem;
    margin: 0 auto;
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .apply-success-title {
      font-size: 1.25rem;
    }
  }
</style>

<!-- eslint-disable max-len -->
<i18n locale="en" lang="yaml">
successTitle: Thank you for your response
successTextOne: An invitation to an online interview has been sent to your email, please use the link from the email to start the online interview.
successTextTwo: If you have 30 minutes of free time, a stable Internet connection and a webcam, then you can go through an online interview by clicking on the "Pass an online interview" button
passInterviewButton: Pass an interview
</i18n>

<i18n locale="ru" lang="yaml">
successTitle: Спасибо за отклик
successTextOne: На ваш электронный адрес отправлено приглашение. Пожалуйста, используйте ссылку из письма, чтобы начать этап онлайн-собеседования.
successTextTwo: При наличии 30 минут свободного времени, стабильного интернет-соединения и работающей веб-камеры вы можете перейти к онлайн-собеседованию, нажав кнопку «Пройти онлайн-собеседование»
passInterviewButton: Пройти онлайн-собеседование
</i18n>
<!-- eslint-enable max-len -->
